module.exports = __webpack_public_path__ + "static/media/logoLoginWhite.3110cd50.png";